import { Tag } from "antd";
import { OrderConst } from "states/order/order.models";

export interface IOrderStatusTagProps {
  status: string;
}

export function OrderStatusTag(props: IOrderStatusTagProps) {
  switch (props.status) {
    case OrderConst.status.pending:
      return (
        <Tag style={{ marginRight: 0 }} color="#fa8c16">
          Đang xử lý
        </Tag>
      );
    case OrderConst.status.onOrder:
      return (
        <Tag style={{ marginRight: 0 }} color="#9254de">
          Đã xác thực
        </Tag>
      );
    case OrderConst.status.shipping:
      return (
        <Tag style={{ marginRight: 0 }} color="#9254de">
          Đang giao
        </Tag>
      );
    case OrderConst.status.received:
      return (
        <Tag style={{ marginRight: 0 }} color="#36cfc9">
          Đã nhận
        </Tag>
      );
    case OrderConst.status.completed:
      return (
        <Tag style={{ marginRight: 0 }} color="success">
          Hoàn thành
        </Tag>
      );
    case OrderConst.status.returning:
      return (
        <Tag style={{ marginRight: 0 }} color="#ffd035">
          Đang hoàn
        </Tag>
      );
    case OrderConst.status.returned:
      return (
        <Tag style={{ marginRight: 0 }} color="#ffd035">
          Đã hoàn
        </Tag>
      );
    default:
      return (
        <Tag style={{ marginRight: 0 }} color="error">
          Hủy
        </Tag>
      );
  }
}
